import React, { useState, useEffect } from 'react';

import { Fab, Tooltip } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  DeleteForever, 
} from "@mui/icons-material";

import { 
  RollPlus
} from "@dndModels";
import { 
  DAMAGE_TYPES
} from "@dndModels/Constants";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import { DamageType } from "@dndModels/Types";

interface Props {
  obj: RollPlus;
  change_time: number;
  disabled?: boolean;
  onChange: (changed: RollPlus) => void; 
  onDelete: () => void; 
}

export default function DamageInput({ 
  obj,
  change_time,
  disabled = false,
  onChange,
  onDelete
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [prev_change_time, setChangeTime] = useState(change_time);
  const [my_obj, setObj] = useState(obj.clone());

  useEffect(() => {
    if (change_time !== prev_change_time) {
      setObj(obj.clone());
      setChangeTime(change_time);
      setReloading(true);
    }
  }, [change_time, prev_change_time, setChangeTime, setReloading, obj, setObj]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderRoll = () => {
    const return_us: any[] = [];
    return_us.push(
      <Grid
        key="count"
        size={{
          xs: 3
        }}>
        <StringBox 
          value={`${my_obj.count}`} 
          name="Count"
          type="number"
          disabled={disabled}
          onChange={(value: string) => {
            my_obj.count = +value;
            onChange(my_obj);
          }}
        />
      </Grid>
    );
    return_us.push(
      <Grid
        key="size"
        size={{
          xs: 3
        }}>
        <SelectStringBox 
          options={["1","4","6","8","10","12"]}
          value={`${my_obj.size}`} 
          name="Size"
          disabled={disabled}
          onChange={(value: string) => {
            my_obj.size = +value;
            onChange(my_obj);
          }}
        />
      </Grid>
    );
    return_us.push(
      <Grid
        key="text"
        size={{
          xs: 3
        }}>
        { my_obj.size === 1 ? `${my_obj.count}` : `${my_obj.count}d${my_obj.size}`}
      </Grid>
    );
    return return_us;
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 2
        }}>
        { !disabled &&
          <Tooltip title={`Delete Damage`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      <Grid
        container
        spacing={0}
        direction="row"
        size={{
          xs: 10
        }}>
        <Grid
          size={{
            xs: 3
          }}>
          <SelectStringBox 
            options={DAMAGE_TYPES}
            value={my_obj.type} 
            name="Type"
            disabled={disabled}
            onChange={(value: DamageType) => {
              const new_obj = my_obj;
              new_obj.type = value;
              onChange(new_obj);
            }}
          />
        </Grid>
        { !reloading && renderRoll() }
      </Grid>
    </Grid>
  );
}
